import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  CompanyStateLead,
  CompanyStateLeadRequest,
  CompanyStateLeadResponse,
  PageResponseV2
} from '../models/empresa.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyStateLeadApiService {
  private readonly apiUrl = `${environment.apiUrl}api/company-state-leads`;

  constructor(private http: HttpClient) { }

  // GET /api/company-state-leads - List all company state leads (paginated)
  getAll(params?: { page?: number; size?: number }): Observable<PageResponseV2<CompanyStateLeadResponse>> {
    let queryParams = new HttpParams();
    if (params?.page != null) queryParams = queryParams.set('page', params.page);
    if (params?.size != null) queryParams = queryParams.set('size', params.size);
    return this.http.get<PageResponseV2<CompanyStateLeadResponse>>(this.apiUrl, { params: queryParams });
  }

  // GET /api/company-state-leads/{id} - Get state lead by ID
  getById(id: number): Observable<CompanyStateLeadResponse> {
    return this.http.get<CompanyStateLeadResponse>(`${this.apiUrl}/${id}`);
  }

  // POST /api/company-state-leads - Create new state lead (requires Sales Rep or higher)
  create(stateLead: CompanyStateLeadRequest): Observable<CompanyStateLeadResponse> {
    return this.http.post<CompanyStateLeadResponse>(this.apiUrl, stateLead);
  }

  // PUT /api/company-state-leads/{id} - Update existing state lead (requires Sales Rep or higher)
  update(id: number, stateLead: CompanyStateLeadRequest): Observable<CompanyStateLeadResponse> {
    return this.http.put<CompanyStateLeadResponse>(`${this.apiUrl}/${id}`, stateLead);
  }

  // DELETE /api/company-state-leads/{id} - Delete state lead (requires Admin or higher)
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
